import { FaCheck } from "react-icons/fa6";

export default function CheckIcon({size}) {
    return <FaCheck size={size} />;
}